import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { ListView } from '@syncfusion/ej2-lists';
import { closest } from '@syncfusion/ej2-base';
import { DragAndDropEventArgs, NodeSelectEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, Query, ReturnOption, Predicate } from '@syncfusion/ej2-data';
import { kpi,kpiInteraction, slakpiInteraction } from './../../../models/slakpi';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-kpi-interaction.component',
  templateUrl: './kpi-interaction.component.html',
  styleUrls: ['./kpi-interaction.component.css']

})
export class KPIInteractionComponent implements OnInit {
  public kpi_data: any;
  public interaction_data: any;
  public kpi_interaction_data: any;
  public permission: number = 1;

  // Mapping TreeView fields property with data source properties
  public fields_kpi: Object;
  public fields_interaction: Object;
  public checkNodes: Object[] = [];
  public allowDragAndDrops: boolean = true;
  public selected_kpiUno: number = 0;
  public selected_kpiPUno: number = 0;
  public isRemoveActive: boolean = false;
  public isMapActive: boolean = false;
  
  @ViewChild("inputObj_KPI", { static: false }) inputObj_KPI: ElementRef;
  @ViewChild("inputObj_Tree", { static: false }) inputObj_Tree: ElementRef;

  public objKPIArr: kpiInteraction;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;

  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: SLAKPIApiService, public adminService: AdminApiService, private router: Router, public utilityService: UtilityService, private spinner: SpinnerVisibilityService, private userService: UserService, private toaster: ToasterService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly') ? true : false;


    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.Refresh_PageData();
  }

  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("KPI Interaction");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        ////User rights
        //this.editSettings = { allowEditing: this.permision_edit, allowAdding: this.permision_add, allowDeleting: this.permision_delete, mode: 'Dialog' };

        //this.toolbar = this.userService.getRights_Toolbar(this.permision_add, this.permision_edit, this.permision_delete);

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  Refresh_PageData() {
    this.objKPIArr = new kpiInteraction();
    this.loadKPI();
    this.loadInteractions();
    this.isRemoveActive = false;
    this.isMapActive = false;
    this.selected_kpiUno = 0;
    this.selected_kpiPUno = 0;
  }

  // Get kpi list
  loadKPI() {
    this.spinner.show();
    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getKPIs(inpValue)
      .subscribe(data => {
        
        this.kpi_data = data;
        this.fields_kpi = { dataSource: this.kpi_data, id: 'strKPIUno', text: 'kpiNameCode', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type' };  
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  // Get Interaction list
  loadInteractions() {
    this.spinner.show();
    let inpValue = new slakpiInteraction();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getKpiInteractions(inpValue)
      .subscribe(data => {
        
        this.interaction_data = data;
        this.fields_interaction = { dataSource: this.interaction_data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
   
  public nodeDrag(args: DragAndDropEventArgs): void {
    if (!this.permision_edit && !this.permision_add) args.dropIndicator = 'e-no-drop';
    if (args != null && args.droppedNodeData != null) {
      if (args.droppedNodeData.id.toString().toLowerCase().indexOf("k") > -1) {
        args.dropIndicator = 'e-no-drop';
      }
      if (args.draggedNodeData.id.toString().toLowerCase().indexOf("i") > -1) {
        args.dropIndicator = 'e-no-drop';
      }
    }
    else if (args != null) {
      args.dropIndicator = 'e-no-drop';
    }
  }
  public dragStop(args: DragAndDropEventArgs): void {
    if (!this.permision_edit && !this.permision_add) { args.cancel = true; return; } 
    if (args != null && args.droppedNodeData != null && args.dropIndicator == "e-drop-in") {
      if (args.draggedNodeData.id.toString().toLowerCase().indexOf("i") > -1) {
        args.cancel = true;
        return;
      }
      if (args.draggedNodeData.id.toString().toLowerCase().indexOf("k") > -1) {
        if (args.droppedNodeData.id.toString().toLowerCase().indexOf("k") > -1) {
          args.cancel = true;
          return;
        }
        else {
                
          if (!this.check_duplicateKPI(args.draggedNodeData.id.toString(), args.droppedNodeData.id.toString())) {
            args.cancel = false;
            this.AddEditKPI_Array(args.draggedNodeData.id.toString(), args.droppedNodeData.id.toString());
            return;
          }
          else {
            args.cancel = true;
           // Swal.fire('Error', 'Duplicates are not allowed', 'warning');
            this.toaster.show('error', 'Error', 'Duplicates are not allowed');
            return;
          }
          
        }
        
      }
    }
    else if (args != null) {
      args.cancel = true;
      return;
    }
  }
  public nodeDropped(args: DragAndDropEventArgs): void {

  }
  check_duplicateKPI(dataKPI: string, dataInteraction: string) {
    var rtnchkval = false;
    var filteredArray = this.interaction_data.filter(function (intData) {
    
      if ((intData.pUno != null && (intData.pUno.toLocaleLowerCase() == dataInteraction.toLocaleLowerCase())) && intData.uno.toLocaleLowerCase() == dataKPI.toLocaleLowerCase()) {
        rtnchkval = true;
      }
    });

    return rtnchkval;
  }
  public onNodeSelecting(args: NodeSelectEventArgs): void {
    let id: any = args.nodeData.id;
    let pid: any = args.nodeData.parentID;
    
    if (id.indexOf('K_') >= 0 || id.indexOf('k_') >= 0) {
      this.selected_kpiUno = id.replace('k_', '').replace('K_', '');
      this.selected_kpiPUno = pid.replace('i_', '').replace('I_', '');
      this.isRemoveActive = true;
    }


  }
  AddEditKPI_Array(dataKPI: string, dataInteraction: string) {
    


    dataKPI = dataKPI.replace('k_', '').replace('K_', '');
    dataInteraction = dataInteraction.replace('i_', '').replace('I_', '');
    let objKPI = new kpiInteraction();
    objKPI.interactionTrnUno = 0;
    objKPI.interactionUno = parseInt(dataInteraction);
    objKPI.kpiUno = parseInt(dataKPI);
    objKPI.tenantUno = this.tenantUno;
    objKPI.userUno = this.login_UserID;
    this.objKPIArr.objkpiInteraction.push(objKPI);
    this.isMapActive = true;
    this.loadKPI(); 
  }

  AddEditKPI() {
    this.isMapActive = false;
    if (this.objKPIArr.objkpiInteraction.length <= 0) {
     // Swal.fire('Error', 'KPI is not mapped ', 'warning');
      this.toaster.show('error', 'Error', 'KPI is not mapped');
      this.objKPIArr = new kpiInteraction();
    }
    else {
      Swal.fire({
        title: '',
        text: 'Please confirm to update',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.objKPIArr.userUno = this.login_UserID
      this.restApi.addKpiInteractions(this.objKPIArr)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '') {
           // Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong');
            //this.Refresh_PageData();
          }
          else {
            //Swal.fire({
            //  type: 'success',
            //  title: 'KPI saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.toaster.show('success', 'Success', 'KPI saved.');
            this.Refresh_PageData();
          } 

          this.spinner.hide();
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      })
    }
    return true;
  
  }
   
  DeleteKPI_Interaction() {
     
    if (this.selected_kpiUno > 0) {
      this.isRemoveActive = false;
      Swal.fire({
        title: '',
        text: 'Please confirm to delete',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {

          let objKPI = new kpiInteraction();
          objKPI.interactionTrnUno = 0;
          objKPI.interactionUno = this.selected_kpiPUno;
          objKPI.kpiUno = this.selected_kpiUno;
          objKPI.userUno = this.login_UserID;
          objKPI.tenantUno = 1;
          this.restApi.deleteKpiInteractions(objKPI)
            .subscribe(data => {
              
              if (data != null && data != undefined && data != '') {
               // Swal.fire('Error', 'Something went wrong', 'error')
                this.toaster.show('error', 'Error', 'Something went wrong');
              }
              else {
                //Swal.fire({
                //  type: 'success',
                //  title: 'KPI deleted.',
                //  showConfirmButton: false,
                //  timer: 1500
                //})
                this.toaster.show('success', 'Success', 'KPI deleted.');
                //this.loadKPI();
                this.loadInteractions();
              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });

          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      });


    }

  }


  changeDataSource_KPI(data) {
    this.fields_kpi = { dataSource: data, id: 'strKPIUno', text: 'kpiNameEn', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type'  };
  }
  //Filtering the TreeNodes
  searchNodes_KPI() {

    let _text = this.inputObj_KPI.nativeElement.value;
    
    let predicats = [], _array = [], _filter = [];
    if (_text.trim() == "") {
      this.changeDataSource_KPI(this.kpi_data);
    }
    else if (_text.trim().length > 1) {
      let predicate = new Predicate('kpiNameEn', 'contains', _text, true);
      let filteredList = new DataManager(this.kpi_data).executeLocal(new Query().where(predicate));
      if (filteredList.length == 0) {
        this.changeDataSource_KPI([]);
      } else {
        this.changeDataSource_KPI(filteredList);
      }
    }
  }

  changeDataSource_Tree(data) {
    this.fields_interaction = { dataSource: data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
  }
  //Filtering the TreeNodes
  searchNodes_Tree() {
    
    let _text = this.inputObj_Tree.nativeElement.value;

    let predicats = [], _array = [], _filter = [];
    if (_text.trim() == "") {
      this.changeDataSource_Tree(this.interaction_data);
    }
    else if (_text.trim().length > 1) {
      let predicate = new Predicate('name', 'contains', _text.trim(), true);
      let filteredList = new DataManager(this.interaction_data).executeLocal(new Query().where(predicate));

      for (var j = 0; j < filteredList.length; j++) {
        _filter.push(filteredList[j]["uno"]);
        var filters = this.getFilterItems(filteredList[j], this.interaction_data);
        for (var i = 0; i < filters.length; i++) {
          if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
            _array.push(filters[i]);
            predicats.push(new Predicate('uno', 'equal', filters[i], false));
          }
        }
      }
      if (filteredList.length == 0) {
        this.changeDataSource_Tree([]);
      } else {
        let query = new Query().where(Predicate.or(predicats));
        let newList = new DataManager(this.interaction_data).executeLocal(query);
        this.changeDataSource_Tree(newList);

      }

    }
  }

  //Find the Parent Nodes for corresponding childs
  getFilterItems(fList, list) {

    let nodes = [];
    nodes.push(fList["uno"]);
    let query2 = new Query().where('uno', 'equal', fList["pUno"], false);
    let fList1 = new DataManager(list).executeLocal(query2);
    if (fList1.length != 0) {
      let pNode = this.getFilterItems(fList1[0], list);
      for (var i = 0; i < pNode.length; i++) {
        if (nodes.indexOf(pNode[i]) == -1 && pNode[i] != null)
          nodes.push(pNode[i]);
      }
      return nodes;
    }
    return nodes;
  }
}
